/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AppointmentType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from '../helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function AppointmentType({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/AppointmentType"
  
}) {
let eventAppointmentTypeDisplayNameValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.type.display_name',
})
let timegridSlotIntervalValueData = fromData.useDataValue({ viewPath,
context: 'timegrid',
path: 'slot_interval',
})
let eventBookingDurationValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'booking_duration',
})
let aggregateData = fromHelpers.isCompactView(timegridSlotIntervalValueData, eventBookingDurationValueData)
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 overflowX={aggregateData ? "hidden" : "auto"}
 overflowY="hidden"
 paddingTop={dtSpaceXxxs}
 whiteSpace={aggregateData ? "nowrap" : "inherit"}
 wordBreak={aggregateData ? "break-word" : "inherit"}
 textOverflow={aggregateData ? "ellipsis" : "inherit"}
 maxHeight={aggregateData ? "18px" : "64px"}
 data="event.appointment.type.display_name"
 text={eventAppointmentTypeDisplayNameValueData}
 weight="regular"
 size="small"
 data="timegrid.slot_interval"
 data="event.booking_duration"
 aggregate="../helpers.js isCompactView"
/>
{children}
</React.Fragment>)
}